/**
 * schedule.tsx
 * 
 * @copyright jnakaso.com
 * 
 */

import { useContext, useEffect, useState } from "react";
import { SettingsContext } from "src/components/contexts";
import { storageService } from "src/services/storageService";
import { Event } from "../services/models";
import { ActionIcon, Card, Center, Group, ScrollArea, Text } from "@mantine/core";
import { ScheduleTable } from "src/components/cards/scheduleCard";
import { IconCalendarUp } from '@tabler/icons-react';

function Schedule() {
    const { settings } = useContext(SettingsContext);
    const [season, setSeason] = useState<number>(new Date().getFullYear());
    const [events, setEvents] = useState<Event[]>([]);
    const [ics, setIcs] = useState<string>("");

    useEffect(() => {
        if (settings) {
            setSeason(Number(settings.season));

        }
    }, [settings]);

    useEffect(() => {
        if (season) {
            storageService.getSeasonFile(season, 'schedule.json')
                .then((text) => setEvents(JSON.parse(text)))
                .catch((e) => console.error(e));
            storageService.getSeasonFile(season, 'psgc-schedule.ics')
                .then((text) => setIcs(text))
                .catch((e) => console.error(e));
        }
    }, [season])

    const handleDownload = () => {
        const filename = "psgc-schedule.ics";

        const blob = new Blob([ics], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // For Firefox
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url); // Cleanup
    };

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
                <Center h={60} bg="var(--mantine-color-gray-light)">
                    <Text fw={800} >{settings?.season} Schedule</Text>
                </Center>
            </Card.Section>
            <Card.Section>
                <Group>
                    <Text fw={400} style={{ padding: '1rem' }}>Import the {settings?.season} schedule to your calendar</Text>
                    <ActionIcon
                        ml="0.5rem"
                        size="xs"
                        aria-label="GOY rules"
                        onClick={handleDownload}>
                        <IconCalendarUp />
                    </ActionIcon>
                </Group>
            </Card.Section>
            <ScrollArea style={{ overflowY: "auto" }}>
                <ScheduleTable events={events} />
            </ScrollArea>
        </Card>
    );

}

export default Schedule;